import ActionColumnComponent from "../../../disaster/components/ActionColumn/ActionColumn";

export const getAllColumns = (viewModal, updateModal, deleteRecord) => {
  const actionColumn = ActionColumnComponent({
    viewModal,
    updateModal,
    deleteRecord,
  });

  return {
    "Insurance Policies": [
      {
        title: "Policy",
        dataIndex: "Policy",
        key: "policy",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Who Is Covered",
        dataIndex: "Who Is Covered",
        key: "monthlyAmount",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Coverage Amounts",
        dataIndex: "Coverage Amounts",
        key: "coverageAmounts",
        // render: (record) => (record ? record : "N/A"),
        render: (record) => 
          record !== undefined && record !== null
          ? `$${Number(record).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
          })}`
        : "N/A",
      },
      {
        title: "Deductibles",
        dataIndex: "Deductibles",
        key: "deductibles",
        // render: (record) => (record ? record : "N/A"),
        render: (record) => 
          record !== undefined && record !== null
          ? `$${Number(record).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
          })}`
        : "N/A",
      },
      {
        title: "Special Riders",
        dataIndex: "Special Riders",
        key: "specialRiders",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
 
   
  };
};
